import useLoading from './useLoading';
import useError from './useError';
import type { Request } from '@/data/requests/Request';
import { ref } from 'vue';

export default <R extends Request<T>, T>(request: R, fallback: string) => {
  const { loading } = useLoading();
  const { error, clearError, handleError } = useError();

  const execute = async (): Promise<T> => {
    clearError();
    loading.value = true;

    try {
      return await request.execute();
    } catch (error) {
      handleError(error, fallback);

      throw error;
    } finally {
      loading.value = false;
    }
  };

  return { loading, error, request: ref(request), execute };
};
